module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-31.7127fa30.svg";